/* ============================================================
   Lijepa naša — theme.js
   Live clock · countdown · obverse/reverse reveal ·
   product variant selection · AJAX cart drawer · index filter
   ============================================================ */
(function(){
  'use strict';
  var $  = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var T = window.__T || {};

  /* ---------- money ---------- */
  var MONEY_FORMAT = (window.Shopify && Shopify.money_format) || '&euro;{{amount_no_decimals}}';
  function formatMoney(cents, fmt){
    fmt = fmt || MONEY_FORMAT;
    if (typeof cents === 'string') cents = cents.replace('.','');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(dec, ts, ds){
      dec = dec == null ? 2 : dec; ts = ts == null ? ',' : ts; ds = ds || '.';
      var n2 = (cents/100).toFixed(dec);
      var parts = n2.split('.');
      var intp = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'+ts);
      return dec ? intp + ds + parts[1] : intp;
    }
    switch((fmt.match(placeholder)||[])[1]){
      case 'amount': value = num(2, ',', '.'); break;
      case 'amount_no_decimals': value = num(0); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.'); break;
      case 'amount_with_space_separator': value = num(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(0, ' '); break;
      default: value = num(2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }
  window.__formatMoney = formatMoney;

  /* ---------- live clock ---------- */
  function tickClocks(){
    $$('[data-clock]').forEach(function(el){
      var tz = el.getAttribute('data-clock') || 'Europe/Zagreb';
      var t;
      try { t = new Date().toLocaleTimeString('en-GB',{timeZone:tz,hour:'2-digit',minute:'2-digit',second:'2-digit'}); }
      catch(e){ t = new Date().toTimeString().slice(0,8); }
      el.innerHTML = t.replace(/:/g,'<i>:</i>');
    });
  }

  /* ---------- countdown ---------- */
  function pad(n){return (n<10?'0':'')+n;}
  function tickCountdowns(){
    $$('[data-countdown]').forEach(function(el){
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if(isNaN(target)) return;
      var diff = Math.max(0, target - Date.now());
      var d=Math.floor(diff/864e5), hh=Math.floor(diff/36e5)%24, m=Math.floor(diff/6e4)%60, s=Math.floor(diff/1e3)%60;
      el.innerHTML = [[T.days||'Days',d],[T.hrs||'Hrs',hh],[T.min||'Min',m],[T.sec||'Sec',s]].map(function(u){
        return '<div class="u"><div class="v">'+pad(u[1])+'</div><div class="k">'+u[0]+'</div></div>';
      }).join('<div class="u"><div class="v"><i>:</i></div></div>');
    });
  }

  /* ---------- obverse/reverse reveal (cards) ---------- */
  document.addEventListener('click', function(e){
    var face = e.target.closest && e.target.closest('.face');
    if(face){
      e.preventDefault(); e.stopPropagation();
      var rv = face.closest('.reveal');
      if(rv) rv.classList.toggle('flip');
    }
  });

  /* ---------- language switcher (close on outside click / Escape) ---------- */
  document.addEventListener('click', function(e){
    $$('details.lang-switch[open]').forEach(function(d){ if(!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') $$('details.lang-switch[open]').forEach(function(d){ d.removeAttribute('open'); });
  });

  /* ---------- index (collection) filter ---------- */
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-filter]');
    if(!a) return;
    e.preventDefault();
    var f = a.getAttribute('data-filter');
    var bar = a.closest('.idx-bar');
    if(bar) $$('[data-filter]', bar).forEach(function(x){x.classList.toggle('on', x===a);});
    $$('.sheet[data-city]').forEach(function(sh){
      sh.classList.toggle('hide', f!=='all' && sh.getAttribute('data-city')!==f);
    });
  });

  /* ---------- cart drawer ---------- */
  var drawer = null, overlay = null;
  function openDrawer(){ if(drawer){drawer.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow='hidden';} }
  function closeDrawer(){ if(drawer){drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow='';} }

  function renderCart(cart){
    var itemsEl = $('#cartItems'); if(!itemsEl) return;
    var fmt = drawer.getAttribute('data-money-format') || MONEY_FORMAT;
    if(!cart.items || !cart.items.length){
      itemsEl.innerHTML = '<div class="empty">'+(T.empty||'Your survey kit is empty.')+'</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function(it){
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2') : '';
        var opts = (it.options_with_values||[]).map(function(o){
          var v = o.value;
          if(v === 'White' && T.colorWhite) v = T.colorWhite;
          else if(v === 'Black' && T.colorBlack) v = T.colorBlack;
          return v;
        }).join(' · ');
        return '<div class="ci" data-key="'+it.key+'">'
          + '<div class="ph">'+(img?'<img src="'+img+'" alt="'+(it.title||'')+'">':'')+'</div>'
          + '<div><div class="nm">'+it.product_title+'</div>'
          + '<div class="va">'+opts+'</div>'
          + '<div class="ci-act"><span class="qty"><button type="button" data-qty="'+it.key+'" data-q="'+(it.quantity-1)+'" aria-label="-1">−</button><b>'+it.quantity+'</b><button type="button" data-qty="'+it.key+'" data-q="'+(it.quantity+1)+'" aria-label="+1">+</button></span>'
          + '<span class="rm" data-remove="'+it.key+'">'+(T.remove||'Remove')+'</span></div></div>'
          + '<div class="pr">'+formatMoney(it.final_line_price, fmt)+'</div></div>';
      }).join('');
    }
    var subEl = $('#cartSub'); if(subEl) subEl.innerHTML = formatMoney(cart.total_price, fmt);
    var countEls = $$('[data-cart-count]');
    countEls.forEach(function(c){ c.textContent = '('+cart.item_count+')'; });
    var hcount = $('#cartHeadCount'); if(hcount) hcount.textContent = cart.item_count;
    var checkoutBtn = $('#cartCheckout'); if(checkoutBtn) checkoutBtn.style.display = cart.item_count ? '' : 'none';
    renderPromo(cart, fmt);
  }

  /* ---------- cart promotions · free-shipping meter, discount lines, cross-sell ---------- */
  function dAttr(n){ return (drawer && drawer.getAttribute(n)) || ''; }
  function esc(v){ return String(v==null?'':v).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  var XSELL = null;
  function xsellData(){
    if(XSELL===null){ try { XSELL = JSON.parse(($('#XsellJson')||{}).textContent||'[]'); } catch(e){ XSELL = []; } }
    return XSELL;
  }
  function renderPromo(cart, fmt){
    if(!drawer || !drawer.hasAttribute('data-promo')) return;
    var free = parseInt(dAttr('data-free-qty'),10) || 2;
    var fee  = parseInt(dAttr('data-ship-fee'),10) || 0;
    var n = cart.item_count || 0;
    var meter = $('#shipMeter'), txt = $('#shipMeterTxt'), bar = $('#shipMeterBar');
    if(meter){
      var left = Math.max(0, free - n);
      meter.hidden = n === 0;
      meter.classList.toggle('done', left === 0);
      if(txt) txt.textContent = left === 0 ? dAttr('data-t-meter-done') : (left === 1 ? dAttr('data-t-meter-one') : dAttr('data-t-meter-many').replace('[N]', left));
      if(bar) bar.style.width = Math.min(100, Math.round(n / free * 100)) + '%';
    }
    var lines = $('#cartLines');
    if(lines){
      var html = '';
      (cart.cart_level_discount_applications || []).forEach(function(d){
        if(!d.total_allocated_amount) return;
        var lbl = dAttr('data-t-discount');
        if(d.value_type === 'percentage') lbl += ' ' + dAttr('data-t-pct').replace('[P]', Math.round(parseFloat(d.value)));
        html += '<div class="ln disc"><span>'+esc(lbl)+'</span><span>−'+formatMoney(d.total_allocated_amount, fmt)+'</span></div>';
      });
      if(n > 0) html += '<div class="ln"><span>'+esc(dAttr('data-t-shipping'))+'</span><span>'+(n >= free ? esc(dAttr('data-t-free')) : formatMoney(fee, fmt))+'</span></div>';
      lines.innerHTML = html;
    }
    renderXsell(cart, fmt);
  }
  function renderXsell(cart, fmt){
    var box = $('#cartXsell'); if(!box) return;
    var data = xsellData();
    if(!cart.item_count || !data.length){ box.hidden = true; box.innerHTML = ''; return; }
    var inCart = {};
    cart.items.forEach(function(it){ inCart[it.product_id] = true; });
    var lastColor = null, lastSize = null, last = cart.items[0];
    ((last && last.options_with_values) || []).forEach(function(o){
      var nm = (o.name||'').toLowerCase();
      if(/colou?r|farbe|boja/.test(nm)) lastColor = /black/i.test(o.value) ? 'black' : 'white';
      if(/size|gr(ö|o|oe)(ß|ss)e|veli/.test(nm)) lastSize = o.value;
    });
    var cands = data.filter(function(p){ return !inCart[p.id] && p.variants.some(function(v){ return v.available; }); });
    cands.sort(function(a,b){ return (b.color===lastColor) - (a.color===lastColor); });
    cands = cands.slice(0, 2);
    if(!cands.length){ box.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = '<div class="xs-h">'+esc(dAttr('data-t-xs-title'))+'</div>' + cands.map(function(p){
      var avail = p.variants.filter(function(v){ return v.available; });
      var pre = avail.filter(function(v){ return v.size === lastSize; })[0] || avail[0];
      var opts = avail.map(function(v){ return '<option value="'+v.id+'"'+(v===pre?' selected':'')+'>'+esc(v.size)+'</option>'; }).join('');
      return '<div class="xs-it">'
        + '<a class="xs-ph" href="'+esc(p.url)+'"><img src="'+esc(p.img)+'" alt="" loading="lazy" width="240" height="240"></a>'
        + '<div class="xs-tx"><a class="nm" href="'+esc(p.url)+'">'+esc(p.title)+'</a>'
        + '<div class="va">'+esc(p.colorName)+' · '+formatMoney(pre.price, fmt)+'</div>'
        + '<div class="xs-act"><label class="visually-hidden" for="xs-'+p.id+'">'+esc(dAttr('data-t-xs-size'))+'</label>'
        + '<select id="xs-'+p.id+'" data-xs-size>'+opts+'</select>'
        + '<button type="button" class="xs-add" data-xs-add>+ '+esc(dAttr('data-t-xs-add'))+'</button></div></div></div>';
    }).join('');
    box.hidden = false;
  }

  function refreshCart(open){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){ renderCart(cart); if(open) openDrawer(); });
  }

  document.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('[data-cart-open]')){ e.preventDefault(); refreshCart(true); }
    if(e.target.closest && e.target.closest('[data-cart-close]')){ e.preventDefault(); closeDrawer(); }
    var qb = e.target.closest && e.target.closest('[data-qty]');
    if(qb){
      e.preventDefault();
      qb.disabled = true;
      fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id:qb.getAttribute('data-qty'), quantity:Math.max(0, parseInt(qb.getAttribute('data-q'),10)||0)})})
        .then(function(r){return r.json();}).then(renderCart).catch(function(){ qb.disabled = false; });
      return;
    }
    var xa = e.target.closest && e.target.closest('[data-xs-add]');
    if(xa){
      e.preventDefault();
      var row = xa.closest('.xs-it'), sel = row && row.querySelector('[data-xs-size]');
      if(!sel) return;
      xa.disabled = true;
      xa.textContent = dAttr('data-t-xs-added') || xa.textContent;
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:parseInt(sel.value,10), quantity:1}]})})
        .then(function(r){return r.json();}).then(function(){ refreshCart(true); })
        .catch(function(){ xa.disabled = false; });
      return;
    }
    var rm = e.target.closest && e.target.closest('[data-remove]');
    if(rm){
      e.preventDefault();
      var key = rm.getAttribute('data-remove');
      fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id:key, quantity:0})})
        .then(function(r){return r.json();}).then(renderCart);
    }
  });

  /* ---------- product form: add to cart ---------- */
  function initProductForm(form){
    var data;
    try { data = JSON.parse($('#ProductJson-'+form.getAttribute('data-section')).textContent); }
    catch(e){ return; }
    var idInput = $('[name="id"]', form);
    var addBtn  = $('[data-add]', form);
    var priceEl = $('#pdpPrice');
    var state = { color:null, size:null, qty:1 };
    var tiersEl = $('[data-tiers]', form);
    var t2 = tiersEl ? (parseFloat(tiersEl.getAttribute('data-t2')) || 0) : 0;
    var t3 = tiersEl ? (parseFloat(tiersEl.getAttribute('data-t3')) || 0) : 0;
    function tierTotal(price, q){
      var sum = price * q, pct = q >= 3 ? t3 : (q === 2 ? t2 : 0);
      return sum - Math.floor(sum * pct / 100);
    }
    var sticky = $('#stickyBuy');

    // token for a color value
    function tok(v){ v=(v||'').toLowerCase(); return v.indexOf('black')>-1?'black':(v.indexOf('white')>-1?'white':v); }

    function currentVariant(){
      return data.variants.filter(function(v){
        return (state.color==null || tok(v.color)===state.color) && (state.size==null || v.size===state.size);
      })[0];
    }

    function updateAvailability(){
      // grey out sizes not available in the current colour
      $$('.szs .z', form).forEach(function(z){
        var sz = z.getAttribute('data-size');
        var ok = data.variants.some(function(v){ return tok(v.color)===state.color && v.size===sz && v.available; });
        z.classList.toggle('soldout', !ok);
      });
      var v = currentVariant();
      if(v){
        idInput.value = v.id;
        if(priceEl){
          priceEl.innerHTML = (v.compare_at_price && v.compare_at_price>v.price ? '<s>'+formatMoney(v.compare_at_price)+'</s> ' : '')
            + formatMoney(v.price) + ' &middot; ' + (T.editionOf||'Edition of') + ' ' + (data.edition||'100');
        }
        var addTxt = $('[data-add-price]');
        if(addTxt) addTxt.innerHTML = formatMoney(tierTotal(v.price, state.qty));
        if(tiersEl){
          [1,2,3].forEach(function(q){
            var pe = $('[data-tier-price="'+q+'"]', tiersEl); if(pe) pe.innerHTML = formatMoney(tierTotal(v.price, q));
            var we = $('[data-tier-was="'+q+'"]', tiersEl); if(we) we.innerHTML = formatMoney(v.price * q);
          });
        }
        if(sticky){
          var sp = $('[data-sb-price]', sticky); if(sp) sp.innerHTML = formatMoney(tierTotal(v.price, state.qty));
          var ss = $('[data-sb-size]', sticky); if(ss) ss.textContent = (state.qty > 1 ? state.qty + ' × ' : '') + (v.size || '');
          var sl = $('[data-sb-label]', sticky); if(sl) sl.textContent = v.available ? (addBtn.getAttribute('data-t-acquire')||'Acquire') : (addBtn.getAttribute('data-t-soldout')||'Sold out');
          var sb = $('[data-sb-add]', sticky); if(sb) sb.disabled = !v.available;
        }
        addBtn.disabled = !v.available;
        var _lbl = addBtn.querySelector('[data-add-label]');
        if(_lbl){ _lbl.textContent = v.available ? (addBtn.getAttribute('data-t-acquire')||'Acquire') : (addBtn.getAttribute('data-t-soldout')||'Sold out'); }
        // history state
        try { history.replaceState({}, '', '?variant='+v.id); } catch(e){}
      } else {
        addBtn.disabled = true;
      }
    }

    function swapImages(){
      var m = data.media[state.color]; if(!m) return;
      var main = $('#pdpMain'); var face = $('#pdpFace');
      if(main){ main.src = m.back; main.setAttribute('data-front', m.front); main.setAttribute('data-back', m.back); }
      if(face) face.textContent = (face.getAttribute('data-t-reverse')||'Reverse');
      // strip
      var strip = $('#pdpStrip');
      if(strip){
        var other = state.color==='white'?'black':'white';
        var om = data.media[other]||{};
        strip.innerHTML =
            thumb(m.front,'PL.I '+(T.obvAbbr||'Obv'),false,"setMainImg('front')")
          + thumb(m.back,'PL.II '+(T.revAbbr||'Rev'),true,"setMainImg('back')")
          + (om.back ? thumb(om.back,'PL.III '+(other==='white'?(T.colorWhite||'White'):(T.colorBlack||'Black')),false,"selColor('"+other+"')") : '');
      }
      // corners
      var ctl = $('#pdpCornerTL'); if(ctl) ctl.textContent = (data.refs[state.color]||'') + ' / ' + data.cityName;
      var cbr = $('#pdpCornerBR'); if(cbr) cbr.innerHTML = (state.color==='white'?(T.colorWhite||'White'):(T.colorBlack||'Black')) + ' &middot; ' + (data.gsm||'237') + ' GSM';
      // placard
      var pimg = $('#placardImg'); if(pimg) pimg.src = m.back;
      // ref + record
      var ref = $('#pdpRef'); if(ref) ref.textContent = data.refs[state.color]||'';
      var rec = $('#pdpRecord');
      if(rec){
        var rb = T.recordBody || 'Ref. [R] · [C] · [K]. Numbered edition of [E], heavyweight 237 gsm cotton, boxy oversized fit. Obverse wordmark, reverse city survey.';
        rec.textContent = rb.replace('[R]', data.refs[state.color]||'').replace('[C]', data.cityName||'').replace('[K]', data.coordinate||'').replace('[E]', data.edition||'100');
      }
      var colorNm = state.color==='white'?(T.colorWhite||'White'):(T.colorBlack||'Black');
      var col = $('#pdpColorName'); if(col) col.textContent = colorNm;
      if(sticky){
        var sc = $('[data-sb-color]', sticky); if(sc) sc.textContent = colorNm;
        var si = $('[data-sb-img]', sticky); if(si) si.src = m.back;
      }
      var cl = $('#pdpColorLabel'); if(cl) cl.textContent = colorNm;
    }

    function thumb(src,label,sel,onclick){
      return '<div class="th'+(sel?' sel':'')+'" onclick="'+onclick+'"><img src="'+src+'" alt=""><span>'+label+'</span></div>';
    }

    window.setMainImg = function(face){
      var main = $('#pdpMain'); if(!main) return;
      main.src = face==='back' ? main.getAttribute('data-back') : main.getAttribute('data-front');
      var f = $('#pdpFace'); if(f) f.textContent = face==='back'?(f.getAttribute('data-t-reverse')||'Reverse'):(f.getAttribute('data-t-obverse')||'Obverse');
      $$('#pdpStrip .th').forEach(function(t,i){ t.classList.toggle('sel', (face==='front'&&i===0)||(face==='back'&&i===1)); });
    };
    window.selColor = function(c){
      state.color = c;
      $$('.states .st', form).forEach(function(b){ b.classList.toggle('sel', tok(b.getAttribute('data-color'))===c); });
      swapImages(); updateAvailability();
    };

    // colour buttons (skip anchor links — those navigate to a sibling product)
    $$('.states .st', form).forEach(function(b){
      if(b.tagName === 'A') return;
      b.addEventListener('click', function(){ window.selColor(tok(b.getAttribute('data-color'))); });
    });
    // size buttons
    $$('.szs .z', form).forEach(function(z){
      z.addEventListener('click', function(){
        if(z.classList.contains('soldout')) return;
        state.size = z.getAttribute('data-size');
        $$('.szs .z', form).forEach(function(x){x.classList.toggle('sel', x===z);});
        updateAvailability();
      });
    });

    // init from pre-selected buttons
    var selColorBtn = $('.states .st.sel', form); if(selColorBtn) state.color = tok(selColorBtn.getAttribute('data-color'));
    var selSizeBtn  = $('.szs .z.sel', form);   if(selSizeBtn)  state.size  = selSizeBtn.getAttribute('data-size');
    if(state.color) { swapImages(); }
    updateAvailability();

    // submit
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var v = currentVariant(); if(!v || !v.available) return;
      addBtn.disabled = true;
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:v.id, quantity:state.qty}]})})
        .then(function(r){return r.json();})
        .then(function(){ refreshCart(true); addBtn.disabled=false; })
        .catch(function(){ addBtn.disabled=false; });
    });

    // offer ladder · 1 / 2 / 3 pieces of the selected variant
    if(tiersEl){
      $$('input[name="ln_tier"]', tiersEl).forEach(function(r){
        r.addEventListener('change', function(){ if(r.checked){ state.qty = parseInt(r.value,10) || 1; updateAvailability(); } });
      });
    }

    // sticky buy bar · appears once the main button has scrolled out of view
    if(sticky){
      var sbBtn = $('[data-sb-add]', sticky);
      var addWrap = $('.add', form);
      var setSticky = function(on){
        sticky.classList.toggle('on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if(sbBtn) sbBtn.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('has-sticky', on);
      };
      if(addWrap){
        var sbTick = false;
        var sbCheck = function(){ sbTick = false; setSticky(addWrap.getBoundingClientRect().bottom < 0); };
        window.addEventListener('scroll', function(){
          if(!sbTick){ sbTick = true; requestAnimationFrame(sbCheck); }
        }, {passive:true});
        sbCheck();
      }
      if(sbBtn) sbBtn.addEventListener('click', function(){
        if(addBtn.disabled) return;
        if(form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }

    // bundle · add both cities (matches the selected size when possible)
    var bundleBtn = $('[data-add-both]');
    var bundleData = null;
    try { var bj = $('#BundleJson-'+form.getAttribute('data-section')); if(bj) bundleData = JSON.parse(bj.textContent); } catch(e){}
    if(bundleBtn && bundleData){
      bundleBtn.addEventListener('click', function(){
        var cur = currentVariant(); if(!cur) return;
        var sib = null;
        if(state.size){ sib = bundleData.variants.filter(function(v){ return v.size===state.size && v.available; })[0]; }
        if(!sib){ sib = bundleData.variants.filter(function(v){ return v.available; })[0]; }
        if(!sib) return;
        bundleBtn.disabled = true;
        var addl = bundleBtn.getAttribute('data-t-add') || bundleBtn.textContent;
        var added = bundleBtn.getAttribute('data-t-added') || 'Added';
        fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:cur.id, quantity:1},{id:sib.id, quantity:1}]})})
          .then(function(r){return r.json();})
          .then(function(){ bundleBtn.textContent = added; refreshCart(true); setTimeout(function(){ bundleBtn.textContent = addl; bundleBtn.disabled = false; }, 1600); })
          .catch(function(){ bundleBtn.disabled = false; });
      });
    }
  }

  /* ---------- size guide dialog ---------- */
  document.addEventListener('click', function(e){
    var o = e.target.closest && e.target.closest('[data-sizeguide-open]');
    var dlg = $('#sizeGuide');
    if(o && dlg){
      e.preventDefault();
      if(dlg.showModal) dlg.showModal(); else dlg.setAttribute('open','');
      return;
    }
    if(!dlg) return;
    if((e.target.closest && e.target.closest('[data-sizeguide-close]')) || e.target === dlg){
      if(dlg.close) dlg.close(); else dlg.removeAttribute('open');
    }
  });

  /* ---------- newsletter demo guard (only when no real form action) ---------- */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if(f.matches && f.matches('[data-demo-subscribe]')){ e.preventDefault(); alert('Demo — connect this form to your email provider or Shopify customer list.'); }
  });

  /* ---------- share · copy link ---------- */
  function fallbackCopy(text){
    try { var ta=document.createElement('textarea'); ta.value=text; ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta); ta.focus(); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); } catch(e){}
  }
  document.addEventListener('click', function(e){
    var cp = e.target.closest && e.target.closest('[data-copy-link]');
    if(!cp) return;
    e.preventDefault();
    var url  = cp.getAttribute('data-url') || location.href;
    var done = cp.getAttribute('data-t-done') || 'Copied';
    var copy = cp.getAttribute('data-t-copy') || 'Copy';
    var lbl  = cp.querySelector('[data-copy-text]');
    function ok(){ if(lbl) lbl.textContent=done; cp.classList.add('done'); setTimeout(function(){ if(lbl) lbl.textContent=copy; cp.classList.remove('done'); }, 1800); }
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(url).then(ok).catch(function(){ fallbackCopy(url); ok(); });
    } else { fallbackCopy(url); ok(); }
  });

  /* ---------- product delivery · cutoff countdown + estimated dates ---------- */
  function initDelivery(){
    var root = $('[data-delivery]'); if(!root) return;
    var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'),10) || 17;
    var pMin = parseInt(root.getAttribute('data-prod-min'),10) || 2;
    var pMax = parseInt(root.getAttribute('data-prod-max'),10) || 5;
    var sMin = parseInt(root.getAttribute('data-ship-min'),10) || 3;
    var sMax = parseInt(root.getAttribute('data-ship-max'),10) || 6;
    var locale = root.getAttribute('data-locale') || document.documentElement.lang || 'de';
    var tBefore = root.getAttribute('data-t-before') || '';
    var tAfter  = root.getAttribute('data-t-after') || '';
    var tToday  = root.getAttribute('data-t-today') || 'Today';
    var sep     = root.getAttribute('data-t-sep') || '–';
    var fmt;
    try { fmt = new Intl.DateTimeFormat(locale, {day:'numeric', month:'short'}); }
    catch(e){ fmt = new Intl.DateTimeFormat('en', {day:'numeric', month:'short'}); }

    var cutBox = $('#pdCut'), cutTxt = $('#pdCutTxt');
    function isWeekend(d){ var g=d.getDay(); return g===0||g===6; }
    function addDays(d,n){ var x=new Date(d); x.setDate(x.getDate()+n); return x; }
    function nextBiz(d){ var x=new Date(d); do{ x=addDays(x,1); }while(isWeekend(x)); return x; }
    function addBiz(d,n){ var x=new Date(d), i=0; while(i<n){ x=addDays(x,1); if(!isWeekend(x)) i++; } return x; }
    function sod(d){ var x=new Date(d); x.setHours(0,0,0,0); return x; }
    function pad(n){ return (n<10?'0':'')+n; }
    function rng(a,b){ var fa=fmt.format(a), fb=fmt.format(b); return fa===fb?fa:(fa+' '+sep+' '+fb); }
    function setDate(k,v){ var el=root.querySelector('[data-date="'+k+'"]'); if(el) el.textContent=v; }
    function renderBefore(ms){
      var h=Math.floor(ms/36e5), m=Math.floor(ms/6e4)%60, s=Math.floor(ms/1e3)%60;
      var chip='<b class="cd"><i>'+pad(h)+'</i>h <i>'+pad(m)+'</i>m <i>'+pad(s)+'</i>s</b>';
      var parts=tBefore.split('{t}');
      if(cutTxt) cutTxt.innerHTML=(parts[0]||'')+chip+(parts[1]||'');
    }
    function compute(){
      var now=new Date(), ct=new Date(now); ct.setHours(cutoffHour,0,0,0);
      var before=(now<ct)&&!isWeekend(now);
      var start = before ? sod(now) : nextBiz(now);
      var shipMinD=addBiz(start,pMin), shipMaxD=addBiz(start,pMax);
      var delMinD=addBiz(shipMinD,sMin), delMaxD=addBiz(shipMaxD,sMax);
      setDate('ordered', tToday);
      setDate('shipped', rng(shipMinD, shipMaxD));
      setDate('delivered', rng(delMinD, delMaxD));
      if(cutBox) cutBox.hidden=false;
      if(before){ renderBefore(ct-now); } else if(cutTxt){ cutTxt.textContent=tAfter; }
      return before;
    }
    var wasBefore = compute();
    setInterval(function(){
      var now=new Date(), ct=new Date(now); ct.setHours(cutoffHour,0,0,0);
      var before=(now<ct)&&!isWeekend(now);
      if(before){ renderBefore(ct-now); wasBefore=true; }
      else if(wasBefore){ wasBefore=false; compute(); }
    }, 1000);
  }

  /* ---------- scroll reveal ---------- */
  function initReveal(){
    var els=$$('.reveal-up'); if(!els.length) return;
    if(!('IntersectionObserver' in window) || (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches)){
      els.forEach(function(e){ e.classList.add('in'); }); return;
    }
    var io=new IntersectionObserver(function(ents){
      ents.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- boot ---------- */
  function boot(){
    drawer  = $('#cartDrawer');
    overlay = $('#cartOverlay');
    if(overlay) overlay.addEventListener('click', closeDrawer);
    tickClocks(); setInterval(tickClocks, 1000);
    tickCountdowns(); setInterval(tickCountdowns, 1000);
    $$('[data-product-form]').forEach(initProductForm);
    initDelivery();
    initReveal();
    // reflect current cart counts on load
    refreshCart(false);
    // active nav
    $$('nav.main a[data-path]').forEach(function(a){
      if(location.pathname.indexOf(a.getAttribute('data-path'))===0 && a.getAttribute('data-path')!=='/') a.classList.add('on');
    });
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
